export default __webpack_public_path__ + "static/media/checkout-success.c006efc5.webp";